import { render } from "./Narayan.vue?vue&type=template&id=2082ebb0"
import script from "./Narayan.vue?vue&type=script&lang=js"
export * from "./Narayan.vue?vue&type=script&lang=js"

import "./Narayan.vue?vue&type=style&index=0&id=2082ebb0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__